/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pendingtasks_Loaderror2Inputs */

const en_pendingtasks_loaderror2 = /** @type {(inputs: Pendingtasks_Loaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to load login tasks, please try again`)
};

/**
* | output |
* | --- |
* | "Unable to load login tasks, please try again" |
*
* @param {Pendingtasks_Loaderror2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const pendingtasks_loaderror2 = /** @type {((inputs?: Pendingtasks_Loaderror2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pendingtasks_Loaderror2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_pendingtasks_loaderror2(inputs)
});
export { pendingtasks_loaderror2 as "pendingTasks_loadError" }